export default __webpack_public_path__ + "static/media/orange-eyes-sq.175c8c58.png";